<template>
    <div class="row" :style="{'background-color': BlockProps[propertyname] }">
        <div class="col col-12 text" style="margin-top:20px">
            <small style="font-size:12px;"><i class="bi bi-info-circle"></i> {{prompt}}</small>
            <ColorPicker style="width:100% !important"
                         theme="dark"
                         :color="BlockProps[propertyname]"
                         @changeColor="OnChangeBGColor"
                         :sucker-hide="true" />
        </div>
        <hr style="margin-top: 5px; margin-bottom:5px;" />
    </div>
</template>

<style>
</style>




<script>
    import { ColorPicker } from 'vue-color-kit'

    export default {
        name: 'propertycoloreditor',
        emits: [],
        components: { ColorPicker },
        props: [
            "blockprops",
            "propertyname",
            "prompt"
        ],
        data() {
            return {                
            };
        },
        methods:
        {      
            OnChangeBGColor(color) {
                  const { r, g, b, a } = color.rgba
                  this.BlockProps[this.propertyname] = `rgba(${r}, ${g}, ${b}, ${a})`
            },
        },
        computed:
        {
            BlockProps: function(){
                return this.blockprops;
            }
        },
        beforeMount: function () {

        },
        mounted: function () {
        
        },
        beforeUnmount: function () {

        }
    }
</script>
